import { type FilterOptionsState } from '@myn/mui';

import { ColumnOptionItem } from '../pages/Builder/types.js';

export const getSelectedOption = (
  value: string | null,
  options?: ColumnOptionItem[],
) => {
  const emptyOption = { displayName: '', value: '' };
  const selectedOption = options?.find((option) => option.value === value);

  return selectedOption || emptyOption;
};

export const getOptionLabel = (option: ColumnOptionItem) => {
  return option.displayName;
};

export const isOptionEqualToValue = (
  option: ColumnOptionItem,
  currentValue: ColumnOptionItem,
) => {
  return option?.value === currentValue?.value;
};

export const filterSoftDeletedOptions = (
  options: ColumnOptionItem[],
  state: FilterOptionsState<ColumnOptionItem>,
) => {
  return options.filter(
    (option) =>
      !option?.isDeleted &&
      option.displayName.toLowerCase().includes(state.inputValue.toLowerCase()),
  );
};

export const getOptionDisabled = (option: ColumnOptionItem) => {
  return !!option?.isDisabled;
};
